import {withProps} from 'recompose';
import styled from '@emotion/styled';
import {Img, LogoText, HeadlineMedium as HeadlineMediumUI, MainTitle} from 'ui';
import {mq} from 'ui/config';

export const Slide = styled('div')({
  position: 'relative',
  zIndex: 2,
  display: 'flex',
  flexDirection: 'column',
  height: 530,
  width: '100vw',
});

export const Image =
  Img
  |> withProps({
    placeholderClass: 'slide-image',
  });

export const SlideText = styled('div')({
  position: 'absolute',
  zIndex: 10,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  paddingLeft: 20,
  paddingRight: 20,
  paddingBottom: 50,
  paddingTop: 50,
  height: 530,
  [mq('small')]: {
    paddingLeft: 5,
    paddingRight: 5,
  },
});

export const SlideTitle = styled(LogoText)({
  marginBottom: 30,
});

export const SlideHeadlineMedium = styled(HeadlineMediumUI)({
  paddingLeft: 18,
  paddingRight: 18,
  marginBottom: 45,
});

export const MainSlideTitle = styled(MainTitle)({
  fontSize: 24,
  lineHeight: '26px',
  marginBottom: 14,
});

export const Mask = styled('div')({
  backgroundImage: 'linear-gradient(180deg, rgba(56,40,24,0.00) 0%, #382818 100%)',
  height: 278,
  width: '100vw',
  position: 'absolute',
  bottom: 0,
  left: 0,
  zIndex: 2,
});
